import { type TextProperties, Text as TextUIKit } from "@react-three/uikit";
import { useCRT } from "../../hooks";

export interface TextProps extends TextProperties {
  children: React.ReactNode;
}

export function Text({ children, ...props }: TextProps) {
  const { fontFamily, fontFamilies } = useCRT();

  return (
    <TextUIKit
      display="flex"
      fontFamily={fontFamily}
      fontFamilies={fontFamilies}
      {...props}
    >
      {children}
    </TextUIKit>
  );
}
